<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 宛先
      span.validation-label 必須
    .register-value.flex-wrap.send-targets
      .loading(v-if="isBusy")
        b-spinner.spinner
        span 宛先読込中...
      button.btn.send-target-select-btn(v-else @click="onTargetBtn") 宛先選択
      //- 宛先グループ（家族）
      .send-target.d-flex(v-for="group in _value.familyGroups" v-if="group.isTarget")
        span.target-name.align-self-center {{ group.name }}
        b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteGroupTarget(group)") X
      //- 宛先グループ（施設関係者）
      .send-target.d-flex(v-for="group in _value.otherUserGroupMemberGroups" v-if="group.isTarget")
        span.target-name.align-self-center {{ group.name }}
        b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteGroupTarget(group)") X
      //- 利用者グループ
      .send-target.d-flex(v-for="group in _value.residentGroups" v-if="group.isTarget")
        span.target-name.align-self-center {{ group.name }}
        b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteGroupTarget(group)") X
      //- 施設関係者グループ
      .send-target.d-flex(v-for="group in _value.otherUserGroups" v-if="group.isTarget")
        span.target-name.align-self-center {{ group.name }}
        b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteGroupTarget(group)") X

    .error-messages(v-if="errors.has('target-groups')")
      div(v-for="error in errors.collect('target-groups')")
        label.error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { userStore } from "@/store/store";

import { PlanType } from "@/commons/services/Plans";
import { SendMessageGroupsGetModel } from "@/commons/services/SendMessageGroups";
import { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import OtherUserGroup from "@/commons/models/OtherUserGroup";

@Component
export default class TargetSelectButton extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: GroupModel;

  @Prop({ required: true })
  isBusy!: boolean;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): GroupModel {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: GroupModel) {
    this.$emit("input", newValue);
    return;
  }

  get _planType(): PlanType {
    return userStore.facility.planType;
  }

  onTargetBtn(): void {
    this.$emit("onTargetBtn");
    return;
  }

  deleteGroupTarget(target: SendMessageGroupTargetModel | ResidentGroupTargetModel | OtherUserGroupTargetModel) {
    target.isTarget = false;
    return;
  }
}

export interface GroupModel {
  familyGroups: Array<SendMessageGroupTargetModel>;
  otherUserGroupMemberGroups: Array<SendMessageGroupTargetModel>;
  residentGroups: Array<ResidentGroupTargetModel>;
  otherUserGroups: Array<OtherUserGroupTargetModel>;
}
export interface SendMessageGroupTargetModel extends SendMessageGroupsGetModel {
  /** モーダルの表示可否 */
  show: boolean;
  /** 宛先対象か否か */
  isTarget: boolean;
  /** グループメンバー数 */
  memberCount: number;
}
export interface ResidentGroupTargetModel extends ResidentGroupsGetModel {
  /** モーダルの表示可否 */
  show: boolean;
  /** 宛先対象か否か */
  isTarget: boolean;
  /** グループメンバー数 */
  memberCount: number;
  /** key */
  key: string;
}
export interface OtherUserGroupTargetModel extends OtherUserGroup {
  /** モーダルの表示可否 */
  show: boolean;
  /** 宛先対象か否か */
  isTarget: boolean;
  /** グループメンバー数 */
  memberCount: number;
  /** key */
  key: string;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";
.send-targets {
  max-width: 600px;

  .send-target-select-btn {
    margin: 0 8px 4px 0;
  }
  .send-target {
    display: inline-block;
    padding: 7px;
    @include font(16px);
    margin: 0 8px 4px 0;
    border-radius: 3px;
    transition: all 0.2s;
    border: 1px solid $form-border-color;

    .target-name {
      margin: 0 8px 0 0 !important;
    }
    .delete-btn {
      margin: 0 !important;
      font-size: 14px !important;
    }
  }
}
</style>
